import React, {useEffect, useState} from 'react';
import {Modal} from "react-bootstrap";
import "../utils/Style/component/modals.scss";
import {formatAccount} from "../features/ValueFormater";
import useS2SAPI from "../api/S2S_API";

function PhoneConfirmationPopup(
    {
        isOpen,
        setIsOpen,
        handleSubmit,
        numberToConfirm,
        amount,
        currencyId,
        handleFeesRadioChange,
        onCorporate,
        setPayload,
        isIndividual,
        dialogClassName = "",
    }) {
    const [mobileNumber, setMobileNumber] = useState("");
    const [error, setError] = useState("");
    const [isFree, setIsFree] = useState(false);

    const [totalFees, setTotalFees] = useState(0);

    const [feesConfig, setFeesConfig] = useState({
        UsdPercentageFee: 0,
        LbpPercentageFee: 0,
        UsdMinimumFeasibleAmount: 0,
        LbpMinimumFeasibleAmount: 0
    });

    const {GetS2STransferConfig} = useS2SAPI();

    useEffect(() => {
        GetS2STransferConfig().then((res) => {
            if (res?.Payload && isIndividual) {
                setFeesConfig(res?.Payload);
            }
        });
    }, []);

    useEffect(() => {
        if (currencyId === 1 && amount < feesConfig?.UsdMinimumFeasibleAmount) {
            setIsFree(true);
        } else if (currencyId === 2 && amount < feesConfig?.LbpMinimumFeasibleAmount) {
            setIsFree(true);
        } else {
            setIsFree(false);
        }

        const fees = currencyId === 1 
            ? parseFloat((amount * feesConfig?.UsdPercentageFee / 100).toFixed(2)) 
            : parseFloat((amount * feesConfig?.LbpPercentageFee / 100).toFixed(2));

            setTotalFees(fees);

            setPayload((prev) => ({
                ...prev,
                FeesAmount: fees
            }));

    }, [amount, currencyId, feesConfig]);




    const handlePaste = (event) => {
        event.preventDefault();
    };

    const handleConfirm = () => {
        let cleanMobileNumber = mobileNumber.startsWith('961') ? mobileNumber.slice(3) : mobileNumber.startsWith('+961') ? mobileNumber.slice(4) : mobileNumber;
        let cleanNumberToConfirm = numberToConfirm.startsWith('961') ? numberToConfirm.slice(3) : numberToConfirm.startsWith('+961') ? numberToConfirm.slice(4) : numberToConfirm;

        if (cleanMobileNumber === cleanNumberToConfirm) {
            handleSubmit();
            setMobileNumber("");
            setError("");
            setIsOpen(false);
            setPayload((prev) => ({
                ...prev,
                ProcessingFeesOnCorporate: true
            }));
        } else {
            setError("Mobile numbers do not match");
        }
    }

    const fees = currencyId === 1 ? feesConfig.UsdPercentageFee : feesConfig.LbpPercentageFee;

    return (
        <div className="pdf-popup">
            <Modal centered dialogClassName={dialogClassName} show={isOpen} onHide={() => {
                setIsOpen(false);
                setMobileNumber("");
                setError("");
                setPayload((prev) => ({
                    ...prev,
                    ProcessingFeesOnCorporate: true
                }));
            }}>
                <Modal.Body>
                    <div className="mobile-confirmation-modal">
                        <div className="header">
                            <div className="modal-header-image">
                                <img src="/Images/caution.png" alt=""/>
                                <div>Receiver is NOT on Suyool</div>
                            </div>
                        </div>
                        {!isFree &&
                            <div className="response-message">{fees}% cash withdrawal fees will be applied</div>
                        }
                    </div>

                    <div className="mobile-confirmation">
                        <div className="modal-listing">

                            <div className="record">
                                <div className="label">Mobile Number Confirmation</div>
                                <div className="input">
                                    <input type="text" value={mobileNumber} onPaste={handlePaste} onChange={(e) => {
                                        setError("");
                                        //only decimal numbers
                                        const {value} = e.target;
                                        if (/^\+?\d*$/.test(value))
                                            setMobileNumber(value)
                                    }}/>
                                    {error && <div className="error">{error}</div>}
                                </div>
                            </div>

                            {/*<div className="record">*/}
                            {/*    <div className="label">Phone Number</div>*/}
                            {/*    <div className="data">{numberToConfirm}</div>*/}
                            {/*</div>*/}
                            <div className="record">
                                <div className="label">Amount</div>
                                <div className="data">{formatAccount(amount, currencyId)}</div>
                            </div>
                            {!isFree &&
                                <>
                                    <div className="record">
                                        <div className="label">Cash Withdrawal Fees</div>
                                        <div className="data">{formatAccount(amount * fees / 100, currencyId)}</div>
                                    </div>
                                    <div className="record">
                                        <div className="label"></div>
                                        <div className="dataEntry currency">
                                            <div className="radio-currency">
                                                <div className="radioCont">
                                                    <label htmlFor="onUs">On Us</label>
                                                    <input
                                                        type="radio"
                                                        id="onUs"
                                                        defaultChecked
                                                        onChange={handleFeesRadioChange}
                                                        name="feeType"
                                                    />
                                                </div>
                                                <div className="radioCont">
                                                    <label htmlFor="onThem">On Them</label>
                                                    <input
                                                        type="radio"
                                                        id="onThem"
                                                        name="feeType"
                                                        onChange={handleFeesRadioChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="record">
                                        <div className="label total">Total Paid</div>
                                        <input className="total-input total" disabled
                                               value={onCorporate ?
                                                   formatAccount(parseFloat((amount + totalFees).toFixed(2)), currencyId)
                                                   :
                                                   formatAccount(amount, currencyId)
                                               }
                                        />
                                    </div>
                                    <div className="record">
                                        <div className="label total">Total Received by User</div>
                                        <input className="total-input total" disabled
                                               value={onCorporate ?
                                                   formatAccount(amount, currencyId)
                                                   :
                                                   formatAccount(parseFloat((amount - totalFees).toFixed(2)), currencyId)
                                               }/>
                                    </div>
                                </>
                            }

                        </div>
                    </div>

                    <div className="buttons">
                        <button id="closeTransferModalBtn" onClick={() => {
                            setIsOpen(false);
                            setMobileNumber("");
                            setError("");
                        }}>Not Now
                        </button>
                        <button id="closeModalBtn" onClick={() => handleConfirm()}>Proceed</button>
                    </div>

                </Modal.Body>
            </Modal>
        </div>
    );
}

export default PhoneConfirmationPopup;
